<template>
  <div class="innerBox">
    <h1>Master Data - Supplier</h1>

    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" v-on:keyup.enter="vue_universal_table.update++"  class="form-control" placeholder="Ketik teks" style="height: 38px;" v-model="filter.search">
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    <!-- <button type="button" class="btn btn-primary" @click="$store.dispatch('triggerAlert', [true, ['test']])">test</button>
    <button type="button" class="btn btn-danger" @click="$store.dispatch('triggerAlert', [false, ['test2', 'test3']])">set False</button> -->

    <vue-universal-table
      :api_url="'/api/v1/masterData/supplier'"
      :filter="filter"
      :special_buttons="vue_universal_table.special_buttons"
      :buttons="vue_universal_table.buttons"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :sort_by="'id'"
      :sort_order="'ASC'"
      @onBuatBaru="modal.add = true"
      @onEdit="editObj"
      @onDelete="deleteObj"
    ></vue-universal-table>

    <new-supplier
      v-if="modal.add"
      @closeModal="modal.add = false"
      @updateTable="updateTable"
    ></new-supplier>

    <edit-supplier
      v-if="modal.edit"
      :editObject="editObject"
      @closeModal="modal.edit = false"
      @updateTable="updateTable"
    ></edit-supplier>

  </div>
</template>

<script>
  import newSupplier from './children/newSupplier'
  import editSupplier from './children/editSupplier'

  export default {
    data () {
      return {
        mobile : this.isMobile(),
        modal : {
          add : false,
          edit : false
        },
        filter : {
          search : ''
        },
        editObject : null,
        vue_universal_table : {
          special_buttons : ['buatBaru'],
          buttons : [
            {
              title : "Edit",
              variable : null,
              class : "btn-outline-primary fas fa-edit",
            },
            {
              title : "Delete",
              variable : "id",
              class : "btn-outline-danger fas fa-times",
            }
          ],
          fields : [
            {
              title : "ID",
              variable : "id"
            },
            {
              title : "Nama Supplier",
              variable : "name"
            },
            {
              title : "CP",
              variable : "contact_person"
            },
            {
              title : "Nomor Telepon",
              variable : "phone_number"
            },
            {
              title : "Alamat",
              variable : "address"
            },
            {
              title : 'Email',
              variable : 'email'
            },
            {
              title : 'Nama Bank',
              variable : 'bank_name'
            },
            {
              title : 'Nomor Rekening',
              variable : 'bank_account'
            },
            {
              title : 'Atas Nama Rekening',
              variable : 'bank_account_name'
            },
            {
              title : "Dibuat Pada",
              variable : "created_at"
            }
          ],
          update : 0
        }
      }
    },
    components : {
      newSupplier,
      editSupplier
    },
    mounted () {

    },
    methods : {
      editObj(obj){
        this.editObject = JSON.parse(obj);
        this.modal.edit = true;
      },
      deleteObj(id){
        this.$http.delete(`/api/v1/masterData/supplier/${id}`)
        .then((resp)=>{
          this.$store.dispatch('triggerAlert', [true, ['Supplier telah berhasil dihapus']])
          this.vue_universal_table.update++;
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      updateTable(){
        this.loadFilterOptions('supplier');
        this.vue_universal_table.update++
      },
    }
  }
</script>

<style scoped>
  .pt20{
    padding-top : 20px;
  }
</style>